module.exports = __webpack_public_path__ + "static/media/chart.d81389c8.svg";